import Http from "../../Utils/Http"
import { localDevCatch } from "../../Utils/utils"
import { mockedJobStatusRunning } from './JobsService.mock'

export const checkJobStatus = async jobId => {
  const result = await Http.get(`/tfg-api/jobs/${jobId}/status`)
    .then(res => res.data)
    .catch((err) => localDevCatch(err, mockedJobStatusRunning))
  return result;
}